import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { getDomainConfig } from '../config/domainConfig';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('acs_admin_token');
    const userData = localStorage.getItem('acs_admin_user');
    if (token && userData) {
      const u = JSON.parse(userData);
      const domainConfig = getDomainConfig();
      // Only restore session if tenant matches current domain
      const domainTenant = domainConfig.tenant_code || '';
      const userTenant = u.tenant?.code || '';
      if (!domainTenant || domainTenant === userTenant) {
        setUser(u);
        setTenant(u.tenant);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      } else {
        localStorage.removeItem('acs_admin_token');
        localStorage.removeItem('acs_admin_user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (tenant_code, email, password) => {
    const res = await axios.post('/api/auth/login', { tenant_code, email, password });
    const { token, user } = res.data;
    localStorage.setItem('acs_admin_token', token);
    localStorage.setItem('acs_admin_user', JSON.stringify(user));
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    setUser(user);
    const domainConfig = getDomainConfig();
    setTenant({ ...user.tenant, tenant_type: domainConfig.tenant_type || user.tenant?.type });
    return user;
  };

  const logout = () => {
    localStorage.removeItem('acs_admin_token');
    localStorage.removeItem('acs_admin_user');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    setTenant(null);
  };

  return (
    <AuthContext.Provider value={{ user, tenant, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
